import { HTTP_METHODS } from '../../constants/HttpConstants';
import {
  sendRequestToDoSelectCentralService,
  sendRequestToServerWithCredentials,
} from '../../utils/request';

/**
 * Bulk Invite Candidates API
 * @param {object} payload - The invite payload
 * @returns {Promise<any>}
 */
export const bulkInviteCandidatesApi = (payload: any) =>
  sendRequestToDoSelectCentralService({
    method: HTTP_METHODS.POST,
    url: 'interview-ai/api/v1/invite',
    data: payload,
  });

/**
 * Bulk Invite Status API
 * @param {string} id - The bulk invite process id
 * @returns {Promise<any>}
 */
export const bulkInviteStatusApi = (id: string) =>
  sendRequestToDoSelectCentralService({
    method: HTTP_METHODS.GET,
    url: `/rpc/bulk_invite/status/${id}`,
  });
